import { Scheme } from 'app/pages/Payment/data';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  convertToPV04FormSchema,
  // checkEmail,
  // standardCountryName,
  findImage,
  isPaymentTokenExpired,
} from 'utils/Utils';
import ErrorModal from '../Modal/ErrorModal';
import useModals from '../Modal/manager/useModal';
import TermsModal from '../Modal/TermsModal';
import PrivacyPolicyModal from '../Modal/PrivacyPolicyModal';
import PV01Form from '../PV01Form';
import PV02Form from '../PV02Form';
import PV03Form from '../PV03Form';
import CustomModal from '../Modal/CustomModal';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { getPaymentRequireInfo, innerSearch } from 'api/Api';
import PV04Form from '../PV04Form';
import { PV04FormSchema } from '../PV04Form/components/types';
import { RequestPV04FormNew } from '../PV04Form/types';
import ArrowPng from 'app/assets/image/common/arrow.png';
import { useMediaQuery } from 'react-responsive';

interface TabBankTransferProps {
  data: { [key: string]: Scheme[] };
  selectedScheme: Scheme;
  setSelectedScheme: (scheme: Scheme) => void;
  setLoading: (method: boolean) => void;
  handleClosed: (e) => void;
  setPopup: (e: Window | null) => void;
  isGlobal: boolean;
}

const TabBankTransfer = ({
  data,
  selectedScheme,
  setSelectedScheme,
  setLoading,
  handleClosed,
  setPopup,
  isGlobal,
}: TabBankTransferProps) => {
  const { t } = useTranslation();
  const foucsTerms = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { openModal } = useModals();
  const { paymentState, setPaymentState, setShopifyState } = usePaymentState();
  const [formState, setFormState] = useState<string>('');
  const [bankSchemeListMap, setBankSchemeListMap] = useState<{
    [key: string]: Scheme[];
  }>({});
  // const [schemeCode, setSchemeCode] = useState<string>('');
  const [agreeCheck, setAgreeCheck] = useState<boolean>(false);
  const [AgreeCheckError, setAgreeCheckError] = useState<boolean>(false);

  const [requireInfoData, setRequireInfoData] = useState<PV04FormSchema | null>(
    null,
  );
  const [open, setOpen] = useState<boolean>(false);
  const isMobileSize = useMediaQuery({ maxWidth: 767 });

  const shouldShowPV04Form = (
    apiResponse: any,
  ): { needsForm: boolean; autoFilledData: Record<string, string> } => {
    const formSchema = convertToPV04FormSchema(apiResponse.requireData);

    const { filteredData, autoFilledValues } = sortPV04RequiredData(
      formSchema.fields,
    );

    const isUserInputRequired = filteredData.length > 0;

    return {
      needsForm: isUserInputRequired,
      autoFilledData: autoFilledValues,
    };
  };

  function sortPV04RequiredData(data: any[]) {
    const filteredData: any[] = [];
    const removedItems: any[] = [];
    const autoFilledValues: Record<string, string> = {};

    data.forEach(item => {
      if (
        item.renderType.startsWith('select_') &&
        item.selectOption &&
        item.selectOption.length === 1
      ) {
        // 제거된 객체 저장
        removedItems.push(item);

        const name = item.name;
        const value = item.selectOption[0].value;

        autoFilledValues[name] = value;
      } else {
        filteredData.push(item);
      }
    });
    return {
      filteredData,
      removedItems,
      autoFilledValues,
    };
  }

  // PV04 진행
  const initiatePV04Flow = async (e: React.FormEvent) => {
    e.preventDefault();

    // 검증
    const validationResult = validatePrerequisites();

    if (!validationResult.isValid) {
      handleValidationError(validationResult.error);
      return;
    }

    // API 호출로 추가 정보 필요여부 확인 및 이후 프로세스 진행
    getRequireInfo.mutate();
  };

  const getRequireInfo = useMutation(
    () => getPaymentRequireInfo(selectedScheme.schemeCd),
    {
      // 추가 필수정보 있는지에 따라 결과 진행
      onSuccess: data => handleRequireInfoResponse(data), // 명시적인 핸들러 사용
      onError: error => {
        console.error('결제 필수 정보 조회 실패:', error);
        navigate('/error');
      },
    },
  );

  const handleRequireInfoResponse = (data: any) => {
    const { needsForm, autoFilledData } = shouldShowPV04Form(data);
    if (needsForm) {
      // 추가 정보 입력이 필요한 경우

      const formSchema = convertToPV04FormSchema(data.requireData);
      setRequireInfoData(formSchema);
      setFormState(selectedScheme.schemeGroup);
    } else {
      // 바로 결제 진행
      handlePayNow(undefined, autoFilledData);
    }
  };

  // 검증 로직 (스킴코드 체크 / 약관동의 체크)
  const validatePrerequisites = () => {
    if (selectedScheme.schemeCd === '') {
      return {
        isValid: false,
        error: { type: 'SCHEME_NOT_SELECTED', message: t('error_bank_select') },
      };
    }

    if (!agreeCheck) {
      return {
        isValid: false,
        error: {
          type: 'AGREEMENT_NOT_CHECKED',
          message: t('error_agree_check'),
        },
      };
    }

    return { isValid: true };
  };

  // 에러 처리 함수
  const handleValidationError = (error: any) => {
    if (error.type === 'AGREEMENT_NOT_CHECKED') {
      setAgreeCheckError(true);
      foucsTerms.current?.scrollIntoView({ behavior: 'smooth' });
    }

    openModal(ErrorModal, { message: error.message });
  };
  let checkPopupTimer;

  useEffect(() => {
    // 핀테크 박람회를 위한 결제수단 추가
    const merchantId = window.sessionStorage.getItem('mid');

    const additionalList: { [key: string]: Scheme[] } = {
      VN: [
        {
          schemeDisplayNm: '9PAY',
          partnerCurr: 'KRW',
          schemeCd: '9PAY',
          schemeCountryCd: 'vn',
          schemeGroup: 'PV01',
          approvalAmount: 100,
        },
      ],
      MX: [
        {
          schemeDisplayNm: 'SPEI',
          partnerCurr: 'KRW',
          schemeCd: 'SPEI',
          schemeCountryCd: 'MX',
          schemeGroup: 'PV01',
          approvalAmount: 100,
        },
      ],
      CL: [
        {
          schemeDisplayNm: 'SERVI PAG',
          partnerCurr: 'KRW',
          schemeCd: 'SERVI PAG',
          schemeCountryCd: 'CL',
          schemeGroup: 'PV01',
          approvalAmount: 100,
        },
      ],
      CO: [
        {
          schemeDisplayNm: 'PSE',
          partnerCurr: 'KRW',
          schemeCd: 'PSE',
          schemeCountryCd: 'CO',
          schemeGroup: 'PV01',
          approvalAmount: 100,
        },
      ],
      PE: [
        {
          schemeDisplayNm: 'PagoEfectivo',
          partnerCurr: 'KRW',
          schemeCd: 'PagoEfectivo',
          schemeCountryCd: 'PE',
          schemeGroup: 'PV01',
          approvalAmount: 100,
        },
        {
          schemeDisplayNm: 'Sfetypay',
          partnerCurr: 'KRW',
          schemeCd: 'Sfetypay',
          schemeCountryCd: 'PE',
          schemeGroup: 'PV01',
          approvalAmount: 100,
        },
      ],
    };

    if (merchantId === '24080014') {
      setBankSchemeListMap(prevState => ({
        ...data,
        ...additionalList,
      }));
    } else {
      setBankSchemeListMap(data);
    }
  }, [data]);

  useEffect(() => {
    setAgreeCheckError(false);
  }, [agreeCheck]);

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(paymentState.tid), {
    onSuccess: data => {
      setLoading(false);
      if (data.data.returnUrl.includes('shopifyConfirm')) {
        setShopifyState(data.data.response);
        navigate('/shopifyConfirm');
      } else {
        // InnerSearch 결과처리
        payResult(data);

        // 결과 상태가 없을경우 예외처리
        if (
          data.data.response.resultStatus === null ||
          data.data.response.resultStatus === undefined
        ) {
          navigate('/error');
        }
      }
    },
    onError: error => {
      setLoading(false);
      navigate('/error');
    },
  });

  // 결제 결과 PaymentState set 및 결과화면 처리
  const payResult = data => {
    // 결과 상태
    const resultStatus = String(data.data.response.resultStatus).toLowerCase();
    // PayType
    const payType = String(data.data.display.payType).toLowerCase();
    setPaymentState(prevState => ({
      ...prevState,
      resultCode: data.data.response.resultCode,
      resultMessage: data.data.response.resultMessage,
      tid: data.data.response.tid,
      orderId: data.data.response.orderId,
      mallReserved: data.data.response.mallReserved,
      // returnUrl: data.data.returnUrl,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));

    // Status에 따른 Paging 처리
    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        payType === 'vbank' || payType === 'otc'
          ? navigate('/vbankPending')
          : navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };

  const selectBankAction = selectBank => {
    setSelectedScheme(selectBank);
    // setSchemeCode(selectBank.schemeCode);
  };

  const handleTermsOrPrivacy = content => {
    if (content === 'SERVICE') {
      openModal(TermsModal, {
        onSubmit: () => {},
      });
    } else {
      openModal(PrivacyPolicyModal, {
        onSubmit: () => {},
      });
    }
  };

  const openPreviousMessage = () => {
    openModal(CustomModal, {
      message: t('move_previous_message'),
      isShowTwoButton: true,
      onSubmit: () => {
        setFormState('');
        setAgreeCheckError(false);
        setAgreeCheck(false);
        setSelectedScheme({
          schemeDisplayNm: '',
          partnerCurr: '',
          schemeCd: '',
          schemeGroup: '',
          approvalAmount: 0,
        });
      },
    });
  };

  const handlePayNow = (
    e?: any,
    schemeRequiredData?: { [key: string]: string },
  ) => {
    if (e) e.preventDefault();
    const validationResult = validatePrerequisites();

    if (!validationResult.isValid) {
      handleValidationError(validationResult.error);
      return;
    }

    if (isPaymentTokenExpired()) {
      // token expired
      navigate('/paymentExpired');
      return;
    }

    const submitFormData: RequestPV04FormNew = {
      schemeCode: selectedScheme.schemeCd,
      amount: paymentState.requestAmount,
      clientKey: paymentState.clientKey,
      currency: paymentState.requestCurrency,
      mid: paymentState.mid,
      orderId: paymentState.orderId,
      productName: paymentState.productName,
      reqDate: paymentState.reqDate,
      webhookUrl: paymentState.webhookUrl,
      returnUrl: paymentState.returnUrl,
      sign: paymentState.sign,
      mallReserved: paymentState.mallReserved,
      authorization: `Bearer ${paymentState.auth}`,
      isMobile: isMobile ? 'Y' : 'N',
      tid: paymentState.tid,
      displayType: 'UI',
    };

    if (schemeRequiredData) {
      submitFormData.schemeRequiredData = schemeRequiredData;
    }

    // Bank Transfer 시 전송되는 Formdata 확인
    // console.log(submitFormData, 'submitFormData');

    openModal(CustomModal, {
      message: t('open_apm_app', { name: selectedScheme.schemeDisplayNm }),
      isShowTwoButton: true,
      onSubmit: () => {
        setLoading(true);
        if (isMobile) {
          navigate('/formSubmit?schemeGroup=PV04', {
            state: { formData: submitFormData },
          });
        } else {
          const popup = window.open(
            '/formSubmit?schemeGroup=PV04',
            '_blank',
            'width=700, height=850',
          );
          setPopup(popup);
          if (popup) {
            setTimeout(() => {
              popup?.postMessage(
                { eventType: 'formData', data: submitFormData },
                window.location.origin,
              );
            }, 1000);
          }
          checkPopupTimer = setInterval(checkPopupClosed, 1000, popup);
        }
      },
    });
  };

  function checkPopupClosed(popup) {
    if (popup && popup.closed) {
      clearInterval(checkPopupTimer);
      const ErrorKey = window.sessionStorage.getItem('isError');
      if (ErrorKey !== 'true') {
        transactResult.mutate();
      }
    }
  }

  // 하단 다음 버튼 클릭시 동작
  const handleNext = e => {
    e.preventDefault();

    if (selectedScheme.schemeCd === '') {
      // apm을 선택하지 않은 경우
      openModal(ErrorModal, {
        message: t('error_bank_select'),
      });
      return;
    }

    if (!agreeCheck) {
      // 약관동의 체크하지 않은 경우
      setAgreeCheckError(true);
      openModal(ErrorModal, {
        message: t('error_agree_check'),
      });

      foucsTerms.current?.scrollIntoView({ behavior: 'smooth' });

      return;
    }
    setAgreeCheckError(false);

    setFormState(selectedScheme.schemeGroup);
  };

  return (
    <>
      {formState ? (
        <>
          {formState === 'PV01' && (
            <PV01Form
              openPrevious={openPreviousMessage}
              selectedScheme={selectedScheme}
              setLoading={setLoading}
              isGlobal={isGlobal}
            />
          )}
          {formState === 'PV02' && (
            <PV02Form
              openPrevious={openPreviousMessage}
              selectedScheme={selectedScheme}
              setLoading={setLoading}
              isGlobal={isGlobal}
            />
          )}
          {formState === 'PV03' && (
            <PV03Form
              openPrevious={openPreviousMessage}
              selectedScheme={selectedScheme}
              setLoading={setLoading}
              isGlobal={isGlobal}
            />
          )}
          {formState === 'PV04' && (
            <PV04Form
              openPrevious={openPreviousMessage}
              onSubmit={handlePayNow}
              requireInfoData={requireInfoData}
              isGlobal={isGlobal}
            />
          )}
        </>
      ) : (
        <div className="tab">
          <div
            id="tab-3"
            className="tab-on current"
            style={{
              height: isGlobal
                ? isMobileSize
                  ? 'calc((var(--vh, 1vh) * 100) - 414px)'
                  : 184
                : isMobileSize
                ? 'calc((var(--vh, 1vh) * 100) - 348px)'
                : 250,
            }}
          >
            {bankSchemeListMap &&
              Object.entries(bankSchemeListMap).map(
                ([country, list], index) => {
                  return (
                    <div className="depth" key={'country_' + country}>
                      <div className="title">
                        {/* {standardCountryName(country)} */}
                        {t(country)}
                      </div>
                      <div
                        style={{
                          clear: 'both',
                          height: 0,
                          overflow: 'hidden',
                        }}
                      ></div>
                      <ul className="sort">
                        {list.map((scheme, index) => {
                          return (
                            <li key={scheme.schemeCd}>
                              <input
                                type="radio"
                                id="sort-apm"
                                checked={selectedScheme === scheme}
                                readOnly
                              />
                              <label
                                htmlFor="sort-apm"
                                onClick={() => selectBankAction(scheme)}
                              >
                                <div className="img">
                                  <img
                                    src={findImage(
                                      `schemeList/${scheme.schemeCountryCd?.toUpperCase()}/${
                                        scheme.schemeCd
                                      }.png`,
                                    )}
                                  />
                                </div>
                              </label>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                },
              )}
          </div>
        </div>
      )}

      {!formState && (
        <>
          <div className="agreeFloatBox">
            <div className="label" ref={foucsTerms}>
              <div className="check">
                <input
                  type="checkbox"
                  id={AgreeCheckError ? 'checkbox error' : 'checkbox'}
                  name="agree"
                  checked={agreeCheck}
                  onChange={e => {
                    setAgreeCheck(e.target.checked);
                  }}
                />

                <label
                  htmlFor={AgreeCheckError ? 'checkbox error' : 'checkbox'}
                ></label>
              </div>
              <div className="columnBox">
                <div className="text">
                  <div
                    onClick={() => setAgreeCheck(!agreeCheck)}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('start_agree_terms')}
                    {t('terms_and_conditions')}
                    {t('and_the')}
                    {t('privacy_policy')}
                    {t('end_agree_terms')}
                  </div>
                  <img
                    className={`arrow ${open ? 'open' : ''}`}
                    src={ArrowPng}
                    alt=""
                    onClick={() => setOpen(!open)}
                  />
                </div>
                <div className={`text toggleRow ${open ? 'open' : ''}`}>
                  <p className="dot">●</p>
                  <span
                    className="link"
                    onClick={() => handleTermsOrPrivacy('SERVICE')}
                  >
                    {t('terms_and_conditions')}
                  </span>
                </div>
                <div className={`text toggleRow ${open ? 'open' : ''}`}>
                  <p className="dot">●</p>
                  <span
                    className="link"
                    onClick={() => handleTermsOrPrivacy('PRIVACY')}
                  >
                    {t('privacy_policy')}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="c-section">
            <div className="box">
              <button className="all-close" onClick={handleClosed}>
                {t('cancel')}
              </button>
              {selectedScheme.schemeGroup === 'PV04' ? (
                <button className="orange" onClick={initiatePV04Flow}>
                  {t('next')}
                </button>
              ) : (
                <button className="orange" onClick={handleNext}>
                  {t('next')}
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TabBankTransfer;
